import {
  Component,
  effect,
  HostListener,
  inject,
  OnInit,
  EffectRef,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';

import {
  ActivatedRoute,
  NavigationEnd,
  Params,
  Router,
  RouterOutlet,
} from '@angular/router';
import { OauthService } from './services/oauth.service';
import { backgrounds } from '../assets/login-backgrounds/login-backgrounds.list';
import { filter, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
  LayoutModule,
} from '@angular/cdk/layout';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language.service';
import { ToasterComponent } from '@kinomap-dev/ng-ui-lib/elements';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LayoutModule, TranslateModule, ToasterComponent],
  providers: [],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private languageService: LanguageService = inject(LanguageService);
  private observer: BreakpointObserver = inject(BreakpointObserver);
  private translateService: TranslateService = inject(TranslateService);
  private router: Router = inject(Router);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  private queryParams: Signal<Params> = toSignal(this.activatedRoute.queryParams, {
    initialValue: this.activatedRoute.snapshot.queryParams,
  });

  xSmallScreen: Signal<boolean> = toSignal(
    this.observer
      .observe(Breakpoints.XSmall)
      .pipe(map((res: BreakpointState) => res.matches)),
    { initialValue: false }
  );
  smallScreen: Signal<boolean> = toSignal(
    this.observer
      .observe(Breakpoints.Small)
      .pipe(map((res: BreakpointState) => res.matches)),
    { initialValue: false }
  );
  mediumScreen: Signal<boolean> = toSignal(
    this.observer
      .observe(Breakpoints.Medium)
      .pipe(map((res: BreakpointState) => res.matches)),
    { initialValue: false }
  );
  largeScreen: Signal<boolean> = toSignal(
    this.observer
      .observe(Breakpoints.Large)
      .pipe(map((res: BreakpointState) => res.matches)),
    { initialValue: false }
  );
  showLogo: Signal<boolean> = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((path) => !path.toString().includes('onboarding'))
    ),
    { initialValue: !this.router.url.includes('onboarding') }
  );
  background: string = this.getbackground();
  heightScreen: WritableSignal<number> = signal(0);

  private registeredLanguages: void = this.translateService.addLangs([
    'en-EN',
    'fr-FR',
    'de-DE',
    'es-ES',
    'it-IT',
    'nl-NL',
    'jp-JP',
  ]);

  private setLanguageFromUrl: EffectRef = effect(() => {
    const queryParams: Params = this.queryParams();
    const paramLang: string | null =
      queryParams['lang'] ||
      this.languageService.getLangFromRedirectUri(queryParams['redirect_uri']);
    this.languageService.setLanguage(paramLang);
  });

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (!(event.target instanceof Window)) {
      return;
    }

    const heigth: number = event.target.innerHeight;
    this.heightScreen.set(heigth);
  }

  getbackground(): string {
    const index: number = Math.floor(Math.random() * backgrounds.length);
    return backgrounds[index];
  }

  ngOnInit(): void {
    this.heightScreen.set(window.innerHeight);
  }
}
